/**
 * Phase H1-η · RequiredVsActual
 *
 * Frozen micro-component (scope §11.2) that renders:
 *
 *   [RM-A] → [RM-B]  [ALT P1]  RMA-042  Supplier-B
 *
 * Collapses to a single-token layout when EXACT (no arrow), and to
 * `DIRECT · <code>` when DIRECT_PURCHASE (no Required label, no arrow).
 *
 * Never renders Required/RMA data on DIRECT — the caller must not
 * pass them.
 */
import React from "react";
import AllocationBadge from "@/components/AllocationBadge";

const codeCls = "font-mono text-[var(--accent)] whitespace-nowrap";

export default function RequiredVsActual({
  requiredCode, actualCode, allocationType,
  alternateApprovalNo, alternatePriority,
  supplier, className = "",
}) {
  const t = String(allocationType || "").toUpperCase();
  if (t === "DIRECT" || t === "DIRECT_PURCHASE") {
    return (
      <div className={`inline-flex items-center gap-1.5 ${className}`}>
        <AllocationBadge type="DIRECT_PURCHASE" size="sm" />
        <span className={codeCls}>{actualCode || "—"}</span>
        {supplier && <span className="text-[10px] text-zinc-500 font-mono">· {supplier}</span>}
      </div>
    );
  }
  if (t === "EXACT" || requiredCode === actualCode) {
    return (
      <div className={`inline-flex items-center gap-1.5 ${className}`}>
        <span className={codeCls}>{actualCode || requiredCode || "—"}</span>
        <AllocationBadge type="EXACT" size="sm" />
      </div>
    );
  }
  // ALT
  return (
    <div className={`inline-flex items-center gap-1.5 flex-wrap ${className}`}>
      <span className={codeCls}>{requiredCode || "—"}</span>
      <span className="text-zinc-500" aria-hidden="true">→</span>
      <span className={codeCls}>{actualCode || "—"}</span>
      <AllocationBadge type="APPROVED_ALTERNATE" size="sm" priority={alternatePriority} />
      {alternateApprovalNo && (
        <span className="text-[10px] text-amber-300 font-mono" title="Directional RMA">
          RMA {alternateApprovalNo}
        </span>
      )}
      {supplier && <span className="text-[10px] text-zinc-500 font-mono">· {supplier}</span>}
    </div>
  );
}
